import { forwardRef } from 'react';
import { cn } from '@simplywallst/ui-core/next';
import ResetSolid from '@simplywallst/ui-core/icons/ResetSolid';

type Props = {
  onClick?: () => void;
};

const styles = cn([
  'absolute end-x1_75 z-10 size-x2',
  'rounded-x2',
  'opacity-50 transition-opacity',
  'hover:opacity-70',
  'cursor-pointer',
  'pointer-events-auto',
]);

export const ResetButton = forwardRef<HTMLButtonElement, Props>(
  ({ onClick }, ref) => (
    <button ref={ref} className={styles} onClick={onClick}>
      <ResetSolid className="absolute top-[-4px] size-x3 fill-[--s-field-input-color-text]" />
    </button>
  )
);

ResetButton.displayName = 'ResetButton';
